import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

declare const WEB_APP_API_KEY: string;
declare const WEB_APP_AUTH_DOMAIN: string;
declare const WEB_APP_DATABASE_URL: string;
declare const WEB_APP_PROJECT_ID: string;
declare const WEB_APP_STORAGE_BUCKET: string;
declare const WEB_APP_MESSAGING_SENDER_ID: string;
declare const COMPASS_APP_APP_ID: string;
declare const COMPASS_APP_MEASUREMENT_ID: string;

const config = {
  apiKey: WEB_APP_API_KEY,
  authDomain: WEB_APP_AUTH_DOMAIN,
  databaseURL: WEB_APP_DATABASE_URL,
  projectId: WEB_APP_PROJECT_ID,
  storageBucket: WEB_APP_STORAGE_BUCKET,
  messagingSenderId: WEB_APP_MESSAGING_SENDER_ID,
  appId: COMPASS_APP_APP_ID,
  measurementId: COMPASS_APP_MEASUREMENT_ID,
};

export const app = initializeApp(config, 'compass-dazzle');
export const auth = getAuth(app);
auth.useDeviceLanguage();
